import _ from "underscore";
import async from "async";
import Operation from "core/models/Operation";
import OperationSet from "core/models/OperationSet";
import MapQuery from "app/models/map/MapQuery";
import Field from "core/models/Field";
import FieldTypes from "core/models/FieldTypes";
import messenger from "app/Messenger";
import mapContext from "app/views/map/MapContext";
import SymbolFactory from "app/models/map/SymbolFactory";

function finishQuery(queryModel) {
  var selectedLayers = queryModel.searchLayers;
  var deferred = new $.Deferred();

  if (queryModel.allInternal) {
    var models = queryModel.runInternalQuery();

    mapContext.setSelection(models);
    return mapContext
      .getOperation("highlight-geometry")
      .action(models)
      .then(function () {
        return mapContext.getOperation("show-geometry-details").action(models);
      });
  } else if (queryModel.allExternal) {
    //Create an external query using the queryModel layers
    var combinedFeaturesFound = [];

    async.each(
      selectedLayers,
      function (layer, cb) {
        var query = new MapQuery(layer);

        query.where(queryModel.toEsriQueryExpression(layer));
        query
          .highlight(SymbolFactory.highlight())
          .done(function (featuresFound) {
            combinedFeaturesFound = combinedFeaturesFound.concat(featuresFound);
            cb();
          })
          .fail(function (err) {
            cb(err);
          });
      },
      function (err) {
        if (err) {
          return deferred.reject(err);
        }

        mapContext.setSelection(combinedFeaturesFound);
        deferred.resolve(
          mapContext
            .getOperation("show-geometry-details")
            .action(combinedFeaturesFound)
        );
      }
    );
    return deferred;
  } else if (selectedLayers.length) {
    //Internal Search
    selectedLayers = queryModel.getSelectedLayers(true);
    var models = queryModel.runInternalQuery();
    var internalResult = mapContext
      .getOperation("highlight-geometry")
      .action(models)
      .then(function () {
        return models.length > 0;
      });

    //External Search
    var combinedFeaturesFound = [];
    selectedLayers = queryModel.getSelectedLayers(false);

    async.each(
      selectedLayers,
      function (layer, cb) {
        var query = new MapQuery(layer);
        query.where(queryModel.toEsriQueryExpression(layer));
        query
          .highlight(SymbolFactory.highlight())
          .done(function (featuresFound) {
            combinedFeaturesFound = combinedFeaturesFound.concat(featuresFound);
            cb();
          })
          .fail(function (err) {
            cb(err);
          });
      },
      function (err) {
        if (err) {
          return deferred.reject(err);
        }

        if (internalResult) models = models.concat(combinedFeaturesFound);
        else models = featuresFound;

        mapContext.setSelection(models);
        deferred.resolve(
          mapContext.getOperation("show-geometry-details").action(models)
        );
      }
    );

    return deferred;
  } else {
    return mapContext.getOperation("show-geometry-details").action([]);
  }
}

export default new OperationSet([
  new Operation({
    id: "basic-search",
    icon: "",
    text: "Basic Search",
    action: function (model, options) {
      var value = options.field.getValue(options.searchModel);

      if (_.isString(value)) {
        value = value.trim();
      }

      model.reset();

      model.and(null, value);

      mapContext.clearSelection();
      return finishQuery(model);
    },
  }),

  new Operation({
    id: "advanced-search",
    icon: "",
    text: "Advanced Search",
    action: function (model, options) {
      var fieldsByKey = model.fieldsByKey;
      var searchModel = options.searchModel;

      model.reset();

      _.each(_.keys(fieldsByKey), function (searchKey) {
        var field = fieldsByKey[searchKey];
        var value = Field.getValue(searchModel, field.get("label"));
        var changed = !!(
          searchModel &&
          searchModel.attributes &&
          searchModel.attributes[searchKey]
        );

        if (changed && (value || field.get("type") == FieldTypes.CheckBox)) {
          model.and(
            field,
            field.get("type") == FieldTypes.CheckBox ? !!value : value
          );
        }
      });

      mapContext.clearSelection();
      return finishQuery(model);
    },
  }),
]);



//////////////////
// WEBPACK FOOTER
// ./public/js/app/operations/map/SearchOperations.js
// module id = 913
// module chunks = 1